import OptionButton from './OptionButton';

type QuestionCardProps = {
  question: {
    id: string;
    questionType?:
      | 'MULTIPLE_CHOICE_SINGLE_ANSWER'
      | 'MULTIPLE_CHOICE_MULTIPLE_ANSWERS';
    question: string;
    options: {
      answerOption: string;
      answerValue: string;
      correctAnswer: boolean;
    }[];
  };
  selectedAnswers: string[];
  onAnswerSelect: (questionId: string, selected: string[]) => void;
};

const QuestionCard = ({
  question,
  selectedAnswers,
  onAnswerSelect
}: QuestionCardProps) => {
  const handleSelect = (value: string) => {
    // Always allow only one answer
    onAnswerSelect(question.id, [value]);
  };

  // ✅ Remove duplicate options (fix for backend duplicates)
  const uniqueOptions = Array.from(
    new Map(
      question.options.map(option => [option.answerValue, option])
    ).values()
  );

  return (
    <div>
      {/* Question */}
      <h3 className='mb-2 text-center text-lg font-semibold text-gray-800'>
        {question.question}
      </h3>

      <p className='mb-4 text-center text-sm italic text-gray-500'>
        Select one option
      </p>

      {/* Options */}
      <div className='flex flex-col gap-2 md:mx-auto md:max-w-4xl lg:mt-4 2xl:w-1/2'>
        {uniqueOptions.map((ans, index) => {
          const optionLabel = String.fromCharCode(65 + index);

          return (
            <OptionButton
              key={ans.answerValue}
              label={`${optionLabel}. ${ans.answerValue}`}
              selected={selectedAnswers.includes(ans.answerValue)}
              onClick={() => handleSelect(ans.answerValue)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;
